module.exports = __webpack_public_path__ + "static/media/baseball.fde6da31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/baseball.svg
// module id = 360
// module chunks = 7